import { Box } from '../../../UI/Box'
import TaskBody from '../../TaskBody'
import {
  ManualApiRewardMetaData,
  SubTask,
} from '../../../../page_components/PoolDetails/Missions/types'
import { ThemedAnchor } from '../../../ThemedButton'
import TaskAllocationAmount from '../../TaskAllocationAmount'
import { P } from '../../../Library/Typeography'

export type Props = {
  subtask: SubTask
  taskId: number
  updateTaskSubmissions: () => Promise<unknown>
  rewardDisplay: string
}

const ManualApiRewardWithLinkTask = ({
  subtask,
  taskId,
  rewardDisplay,
}: Props) => {
  const { publicName, instructions, metaData } = subtask
  const title = publicName ?? 'ZAP Value Index (ZVI) in partnership with Nansen'
  const description =
    instructions ??
    'Verify your wallet to earn a reputation score based on your on-chain activity, including active months, tokens transacted, and cumulative gas spent.'

  const { redirectLink } = metaData as ManualApiRewardMetaData

  const handleClick = () => {
    const completedManualApiMissions = localStorage.getItem('completedManualApiMissions')
    const completedManualApiMissionsArray = completedManualApiMissions ? JSON.parse(completedManualApiMissions) : []
    localStorage.setItem('completedManualApiMissions', JSON.stringify([...completedManualApiMissionsArray, taskId]))
  }

  return (
    <TaskBody
      taskId={taskId}
      title={title}
      description={description}
      error={''}
      extra={
        <TaskAllocationAmount
          taskId={taskId}
          rewardDisplay={rewardDisplay}
        />
      }
      actions={
        <Box dc g={12} fu aw>
          <P>XP for this mission is updated Weekly.</P>
          <ThemedAnchor
            $styleType="primary"
            href={redirectLink}
            onClick={handleClick}
          >
            Visit Link
          </ThemedAnchor>
        </Box>
      }
    />
  )
}

export default ManualApiRewardWithLinkTask
